/*
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * External dependencies
 */
import { createContext } from '@googleforcreators/react';

/**
 * Internal dependencies
 */
import { noop } from '../../utils/noop';
import type { HelpCenterContext } from './types';

export default createContext<HelpCenterContext>({
  state: {
    isOpen: false,
    isOpeningToTip: false,
    navigationIndex: -1,
    navigationFlow: [],
    isLeftToRightTransition: false,
    hasBottomNavigation: false,
    isPrevDisabled: false,
    isNextDisabled: false,
    readTips: {},
    readError: false,
    unreadTipsCount: 0,
    isHydrated: false,
    tips: {},
    tipKeys: [],
  },
  actions: {
    goToNext: noop,
    goToPrev: noop,
    goToMenu: noop,
    goToTip: noop,
    openToUnreadTip: noop,
    toggle: noop,
    close: noop,
    hydrateReadTipsSuccess: noop,
    persistingReadTipsError: noop,
  },
});
